import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/fmp.css';

const QUALIDADE_COR = {
  'Ótima': 'success',
  'Boa': 'primary',
  'Regular': 'warning',
  'Ruim': 'danger',
};


const getDiasCor = (dias) => {
  if (dias === null) return 'secondary';
  if (dias <= 30) return 'success';
  if (dias <= 60) return 'warning';
  return 'danger';
};

const Contabil_reunioes = () => {
  const [clientes, setClientes] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [filtro, setFiltro] = useState('');
  const [ordenacao, setOrdenacao] = useState('dias_desc');

  const navigate = useNavigate();

  const handleClienteClick = (c) => {
    localStorage.setItem('reuniao_cliente', JSON.stringify(c));
    navigate('/Reunioes');
  };

  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    setCarregando(true);
    setErro('');
    const accessToken = localStorage.getItem('access');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/painel-reunioes-geral/`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (response.data.success) {
        setClientes(response.data.clientes);
      }
    } catch {
      setErro('Erro ao carregar dados. Tente novamente.');
    } finally {
      setCarregando(false);
    }
  };

  const clientesFiltrados = clientes
    .filter((c) => {
      const termo = filtro.toLowerCase();
      return (
        c.empresa?.toLowerCase().includes(termo) ||
        String(c.numero_dominio ?? '').toLowerCase().includes(termo) ||
        c.operador?.toLowerCase().includes(termo)
      );
    })
    .sort((a, b) => {
      switch (ordenacao) {
        case 'dias_desc':
          if (a.dias_desde_ultima === null && b.dias_desde_ultima === null) return 0;
          if (a.dias_desde_ultima === null) return -1;
          if (b.dias_desde_ultima === null) return 1;
          return b.dias_desde_ultima - a.dias_desde_ultima;
        case 'dias_asc':
          if (a.dias_desde_ultima === null && b.dias_desde_ultima === null) return 0;
          if (a.dias_desde_ultima === null) return 1;
          if (b.dias_desde_ultima === null) return -1;
          return a.dias_desde_ultima - b.dias_desde_ultima;
        case 'empresa':
          return (a.empresa || '').localeCompare(b.empresa || '');
        case 'reunioes_desc':
          return b.total_reunioes - a.total_reunioes;
        default:
          return 0;
      }
    });

  const semReuniao = clientes.filter((c) => c.total_reunioes === 0).length;
  const comReuniao = clientes.filter((c) => c.total_reunioes > 0).length;
  const mediaDias = (() => {
    const validos = clientes.filter((c) => c.dias_desde_ultima !== null);
    if (!validos.length) return 0;
    return Math.round(validos.reduce((acc, c) => acc + c.dias_desde_ultima, 0) / validos.length);
  })();

  return (
    <div className="das-page">
      <div className="container-fluid mt-4">

        {/* Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm" style={{ background: 'linear-gradient(135deg, #ffffff 0%, #ffffff 100%)' }}>
              <div className="card-body text-dark">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <div className="mb-3">
                      <span className="badge bg-warning text-dark" style={{ fontSize: '14px', fontWeight: '500' }}>
                        <i className="fas fa-history me-1"></i>
                        Painel Geral
                      </span>
                    </div>
                    <div className="d-flex align-items-center mb-1">
                      <i className="fas fa-calendar-check header-icon me-2"></i>
                      <h2 className="titulo-pagina m-0">Reuniões Contábeis — Visão Geral</h2>
                    </div>
                    <p className="mb-0 text-dark">
                      <i className="fas fa-clock me-2"></i>
                      Acompanhe quantos dias fazem desde a última reunião com cada cliente
                    </p>
                  </div>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={carregarDados}
                      disabled={carregando}
                    >
                      <i className={`fas fa-sync-alt me-1 ${carregando ? 'fa-spin' : ''}`}></i>
                      Atualizar
                    </button>
                    <button
                      className="btn btn-sm"
                      onClick={() => navigate('/Contabilidade')}
                      style={{ backgroundColor: '#00205b', borderColor: '#00205b', color: '#fff' }}
                    >
                      <i className="fas fa-arrow-left me-1"></i>
                      Voltar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Cards de Resumo */}
        <div className="row g-3 mb-4">
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center">
              <div className="card-body py-3">
                <div className="fs-3 fw-bold text-primary">{clientes.length}</div>
                <small className="text-muted">Total de Clientes</small>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center">
              <div className="card-body py-3">
                <div className="fs-3 fw-bold text-success">{comReuniao}</div>
                <small className="text-muted">Com Reunião Registrada</small>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center">
              <div className="card-body py-3">
                <div className="fs-3 fw-bold text-danger">{semReuniao}</div>
                <small className="text-muted">Sem Nenhuma Reunião</small>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card border-0 shadow-sm text-center">
              <div className="card-body py-3">
                <div className="fs-3 fw-bold text-warning">{mediaDias}</div>
                <small className="text-muted">Média de Dias Desde Última</small>
              </div>
            </div>
          </div>
        </div>

        {/* Erro */}
        {erro && (
          <div className="alert alert-danger mb-4">
            <i className="fas fa-exclamation-circle me-2"></i>
            {erro}
          </div>
        )}

        {/* Filtros */}
        <div className="row mb-3 g-2">
          <div className="col-md-6">
            <div className="input-group">
              <span className="input-group-text bg-white">
                <i className="fas fa-search text-muted"></i>
              </span>
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por empresa, domínio ou operador..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {filtro && (
                <button className="btn btn-outline-secondary" onClick={() => setFiltro('')} aria-label="Limpar busca">
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>
          </div>
          <div className="col-md-3">
            <select
              className="form-select"
              value={ordenacao}
              onChange={(e) => setOrdenacao(e.target.value)}
            >
              <option value="dias_desc">Mais dias sem reunião primeiro</option>
              <option value="dias_asc">Menos dias sem reunião primeiro</option>
              <option value="empresa">Empresa (A-Z)</option>
              <option value="reunioes_desc">Mais reuniões primeiro</option>
            </select>
          </div>
          <div className="col-md-3 d-flex align-items-center">
            <small className="text-muted">
              Exibindo <strong>{clientesFiltrados.length}</strong> de {clientes.length} clientes
            </small>
          </div>
        </div>

        {/* Legenda de cores */}
        <div className="d-flex gap-3 mb-3 flex-wrap">
          <small className="text-muted d-flex align-items-center gap-1">
            <span className="badge bg-success">●</span> até 30 dias
          </small>
          <small className="text-muted d-flex align-items-center gap-1">
            <span className="badge bg-warning text-dark">●</span> 31–60 dias
          </small>
          <small className="text-muted d-flex align-items-center gap-1">
            <span className="badge bg-danger">●</span> mais de 60 dias
          </small>
          <small className="text-muted d-flex align-items-center gap-1">
            <span className="badge bg-secondary">●</span> sem reunião
          </small>
        </div>

        {/* Tabela */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body p-0">
            {carregando ? (
              <div className="text-center py-5">
                <span className="spinner-border text-primary" role="status"></span>
                <p className="text-muted mt-3 mb-0">Carregando dados...</p>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-hover mb-0 align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '80px' }}>Nº Dom.</th>
                      <th>Empresa</th>
                      <th>Operador</th>
                      <th className="text-center">Última Reunião</th>
                      <th className="text-center">Dias Desde Última</th>
                      <th className="text-center">Total Reuniões</th>
                      <th className="text-center">Último BI</th>
                      <th className="text-center">Última Qualidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {clientesFiltrados.map((c) => (
                      <tr
                        key={c.numero_dominio}
                        style={{ cursor: 'pointer' }}
                        role="button"
                        tabIndex={0}
                        onClick={() => handleClienteClick(c)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleClienteClick(c);
                          }
                        }}
                        title="Clique para ver o histórico de reuniões"
                      >
                        <td>
                          <span className="badge bg-light text-dark border">{c.numero_dominio}</span>
                        </td>
                        <td>
                          <span className="fw-semibold">{c.empresa}</span>
                        </td>
                        <td>
                          <small className="text-muted">
                            <i className="fas fa-user me-1"></i>
                            {c.operador}
                          </small>
                        </td>
                        <td className="text-center">
                          {c.ultima_reuniao ? (
                            <span>
                              <i className="fas fa-calendar-alt me-1 text-muted"></i>
                              {c.ultima_reuniao}
                            </span>
                          ) : (
                            <span className="text-muted fst-italic">Não possui reunião</span>
                          )}
                        </td>
                        <td className="text-center">
                          <span className={`badge bg-${getDiasCor(c.dias_desde_ultima)} fs-6 px-3 py-2`}>
                            {c.dias_desde_ultima !== null
                              ? `${c.dias_desde_ultima} dias`
                              : 'Sem reunião'}
                          </span>
                        </td>
                        <td className="text-center">
                          <span className={`badge ${c.total_reunioes > 0 ? 'bg-primary' : 'bg-secondary'}`}>
                            {c.total_reunioes}
                          </span>
                        </td>
                        <td className="text-center">
                          {c.total_reunioes > 0 ? (
                            <span className={`badge ${c.ultimo_bi === 'Sim' ? 'bg-success' : 'bg-secondary'}`}>
                              {c.ultimo_bi}
                            </span>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                        <td className="text-center">
                          {c.total_reunioes > 0 && c.ultima_qualidade !== '-' ? (
                            <span className={`badge bg-${QUALIDADE_COR[c.ultima_qualidade] || 'secondary'}`}>
                              {c.ultima_qualidade}
                            </span>
                          ) : (
                            <span className="text-muted">—</span>
                          )}
                        </td>
                      </tr>
                    ))}
                    {clientesFiltrados.length === 0 && !carregando && (
                      <tr>
                        <td colSpan="8" className="text-center py-5 text-muted">
                          <i className="fas fa-search fa-2x mb-3 d-block opacity-50"></i>
                          Nenhum cliente encontrado com os filtros aplicados.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Contabil_reunioes;
